var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInteractivelearning(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 180 180",
    enableBackground: "new 0 0 180 180",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#333333",
    d: "M146.179,83.943h-3.884c-0.212,0-0.385-0.172-0.385-0.384c0-0.213,0.173-0.384,0.385-0.384h3.884 c0.212,0,0.385,0.171,0.385,0.384C146.564,83.771,146.391,83.943,146.179,83.943z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#333333",
    d: "M144.153,85.549c-0.212,0-0.384-0.173-0.384-0.385v-3.338c0-0.212,0.172-0.384,0.384-0.384 s0.384,0.172,0.384,0.384v3.338C144.537,85.376,144.365,85.549,144.153,85.549z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_729_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFDB76",
    d: "M154.623,90c0,35.69-28.934,64.623-64.623,64.623c-35.688,0-64.622-28.932-64.622-64.623 c0-35.689,28.934-64.622,64.622-64.622C125.689,25.378,154.623,54.31,154.623,90z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#333333",
    d: "M57.104,46.514h-9.818c-0.212,0-0.385-0.172-0.385-0.384c0-0.213,0.173-0.384,0.385-0.384h9.818 c0.211,0,0.383,0.171,0.383,0.384C57.487,46.343,57.315,46.514,57.104,46.514z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#333333",
    d: "M60.516,44.333h-1.585c-0.213,0-0.385-0.172-0.385-0.384c0-0.213,0.172-0.384,0.385-0.384h1.585 c0.211,0,0.384,0.171,0.384,0.384C60.9,44.161,60.727,44.333,60.516,44.333z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#333333",
    d: "M62.405,49.361H60.82c-0.213,0-0.385-0.173-0.385-0.385c0-0.212,0.172-0.385,0.385-0.385h1.585 c0.212,0,0.385,0.173,0.385,0.385C62.79,49.188,62.617,49.361,62.405,49.361z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#333333",
    d: "M57.104,44.333h-5.979c-0.211,0-0.384-0.172-0.384-0.384c0-0.213,0.173-0.384,0.384-0.384h5.979 c0.211,0,0.383,0.171,0.383,0.384C57.487,44.161,57.315,44.333,57.104,44.333z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#333333",
    d: "M58.412,61.128h-1.586c-0.212,0-0.384-0.171-0.384-0.383c0-0.213,0.172-0.385,0.384-0.385h1.586 c0.212,0,0.384,0.172,0.384,0.385C58.795,60.957,58.624,61.128,58.412,61.128z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#333333",
    d: "M54.999,61.128H49.02c-0.211,0-0.383-0.171-0.383-0.383c0-0.213,0.172-0.385,0.383-0.385h5.979 c0.212,0,0.385,0.172,0.385,0.385C55.383,60.957,55.21,61.128,54.999,61.128z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#333333",
    d: "M66.013,42.116h-7.218c-0.212,0-0.383-0.173-0.383-0.385c0-0.212,0.171-0.385,0.383-0.385h7.218 c0.212,0,0.384,0.173,0.384,0.385C66.397,41.943,66.225,42.116,66.013,42.116z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#333333",
    d: "M136.666,55.808h-10.17c-0.212,0-0.385-0.171-0.385-0.384c0-0.211,0.173-0.384,0.385-0.384h10.17 c0.212,0,0.385,0.173,0.385,0.384C137.051,55.637,136.878,55.808,136.666,55.808z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#333333",
    d: "M124.604,58.579h-1.643c-0.213,0-0.385-0.171-0.385-0.383c0-0.213,0.172-0.385,0.385-0.385h1.643 c0.211,0,0.383,0.172,0.383,0.385C124.987,58.408,124.815,58.579,124.604,58.579z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#333333",
    d: "M122.646,52.196h-1.643c-0.212,0-0.384-0.173-0.384-0.385c0-0.212,0.172-0.385,0.384-0.385h1.643 c0.212,0,0.384,0.173,0.384,0.385C123.03,52.023,122.858,52.196,122.646,52.196z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#333333",
    d: "M132.69,58.579h-6.193c-0.212,0-0.385-0.171-0.385-0.383c0-0.213,0.173-0.385,0.385-0.385h6.193 c0.212,0,0.383,0.172,0.383,0.385C133.073,58.408,132.902,58.579,132.69,58.579z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#333333",
    d: "M124.743,61.394h-7.477c-0.212,0-0.385-0.172-0.385-0.384c0-0.212,0.173-0.384,0.385-0.384h7.477 c0.212,0,0.383,0.172,0.383,0.384C125.125,61.222,124.955,61.394,124.743,61.394z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#333333",
    d: "M151.188,93.259h-6.951c-0.211,0-0.384-0.172-0.384-0.384c0-0.213,0.173-0.385,0.384-0.385h6.951 c0.212,0,0.384,0.172,0.384,0.385C151.572,93.087,151.4,93.259,151.188,93.259z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#333333",
    d: "M142.944,96.028h-1.123c-0.212,0-0.384-0.171-0.384-0.384c0-0.211,0.172-0.384,0.384-0.384h1.123 c0.212,0,0.385,0.173,0.385,0.384C143.329,95.857,143.156,96.028,142.944,96.028z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#333333",
    d: "M141.606,89.644h-1.122c-0.212,0-0.385-0.172-0.385-0.384c0-0.212,0.173-0.384,0.385-0.384h1.122 c0.212,0,0.384,0.172,0.384,0.384C141.99,89.472,141.818,89.644,141.606,89.644z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#333333",
    d: "M148.469,96.028h-4.232c-0.211,0-0.384-0.171-0.384-0.384c0-0.211,0.173-0.384,0.384-0.384h4.232 c0.213,0,0.385,0.173,0.385,0.384C148.854,95.857,148.682,96.028,148.469,96.028z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#333333",
    d: "M143.039,98.844h-5.11c-0.212,0-0.384-0.171-0.384-0.384c0-0.212,0.172-0.384,0.384-0.384h5.11 c0.212,0,0.384,0.172,0.384,0.384C143.422,98.674,143.25,98.844,143.039,98.844z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#333333",
    d: "M54.29,53.503h-3.269c-0.212,0-0.384-0.172-0.384-0.385c0-0.212,0.172-0.383,0.384-0.383h3.269 c0.212,0,0.384,0.171,0.384,0.383C54.673,53.331,54.501,53.503,54.29,53.503z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#333333",
    d: "M52.583,54.952c-0.212,0-0.384-0.173-0.384-0.385v-3.013c0-0.213,0.172-0.385,0.384-0.385 s0.385,0.172,0.385,0.385v3.013C52.968,54.779,52.795,54.952,52.583,54.952z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#333333",
    d: "M87.998,145.032H77.827c-0.212,0-0.383-0.172-0.383-0.385c0-0.211,0.171-0.383,0.383-0.383h10.171 c0.213,0,0.385,0.172,0.385,0.383C88.382,144.861,88.21,145.032,87.998,145.032z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#333333",
    d: "M91.534,140.382h-1.643c-0.212,0-0.385-0.174-0.385-0.385c0-0.213,0.173-0.383,0.385-0.383h1.643 c0.212,0,0.383,0.17,0.383,0.383C91.916,140.208,91.746,140.382,91.534,140.382z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#333333",
    d: "M93.491,151.099h-1.643c-0.213,0-0.384-0.172-0.384-0.383c0-0.213,0.171-0.385,0.384-0.385h1.643 c0.211,0,0.384,0.172,0.384,0.385C93.874,150.927,93.702,151.099,93.491,151.099z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#333333",
    d: "M87.998,140.382h-6.192c-0.213,0-0.385-0.174-0.385-0.385c0-0.213,0.172-0.383,0.385-0.383h6.192 c0.213,0,0.385,0.17,0.385,0.383C88.382,140.208,88.21,140.382,87.998,140.382z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#333333",
    d: "M97.229,135.654h-7.477c-0.213,0-0.385-0.172-0.385-0.385c0-0.211,0.172-0.383,0.385-0.383h7.477 c0.212,0,0.383,0.172,0.383,0.383C97.612,135.482,97.441,135.654,97.229,135.654z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#333333",
    d: "M102.004,145.361h-3.884c-0.212,0-0.385-0.172-0.385-0.385c0-0.211,0.173-0.385,0.385-0.385h3.884 c0.212,0,0.384,0.174,0.384,0.385C102.388,145.189,102.216,145.361,102.004,145.361z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#333333",
    d: "M99.978,147.47c-0.213,0-0.384-0.17-0.384-0.383v-4.391c0-0.213,0.171-0.385,0.384-0.385 c0.211,0,0.384,0.172,0.384,0.385v4.391C100.362,147.3,100.189,147.47,99.978,147.47z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#333333",
    d: "M128.992,46.902h-3.884c-0.212,0-0.384-0.171-0.384-0.384c0-0.212,0.172-0.384,0.384-0.384h3.884 c0.213,0,0.385,0.172,0.385,0.384C129.376,46.731,129.205,46.902,128.992,46.902z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#333333",
    d: "M126.966,49.012c-0.212,0-0.385-0.171-0.385-0.383v-4.392c0-0.212,0.173-0.384,0.385-0.384 c0.212,0,0.383,0.172,0.383,0.384v4.392C127.349,48.842,127.178,49.012,126.966,49.012z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#333333",
    d: "M36.786,126.585v2.639c0,1.459,1.155,2.643,2.58,2.643h101.27c1.424,0,2.58-1.184,2.58-2.643v-2.639 H36.786z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#686868",
    d: "M138.291,126.585V70.713c0-3.108-2.461-5.627-5.498-5.627H47.207c-3.036,0-5.498,2.519-5.498,5.627 v55.872H138.291z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 46.505,
    y: 70.419,
    fill: "#CCCBC9",
    width: 86.989,
    height: 51.845
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_338_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 67.814,
    y: 88.174,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#FFDB76",
    width: 43.087,
    height: 12.826
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_336_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 67.814,
    y: 94.587,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#FFDB76",
    width: 43.087,
    height: 6.413
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 103.65,
    y: 88.174,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#333333",
    width: 1.609,
    height: 12.826
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 95.976,
    y: 88.174,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#333333",
    width: 1.609,
    height: 12.826
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 70.754,
    y: 88.174,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#333333",
    width: 1.609,
    height: 12.826
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#333333",
    d: "M100.484,92.429c-0.682,0-1.235-0.553-1.235-1.233 c0-0.683,0.554-1.235,1.235-1.235c0.682,0,1.234,0.553,1.234,1.235C101.718,91.877,101.166,92.429,100.484,92.429z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#333333",
    d: "M100.484,95.821c-0.682,0-1.235-0.552-1.235-1.234 c0-0.681,0.554-1.233,1.235-1.233c0.682,0,1.234,0.553,1.234,1.233C101.718,95.269,101.166,95.821,100.484,95.821z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#333333",
    d: "M100.484,99.213c-0.682,0-1.235-0.552-1.235-1.233 c0-0.683,0.554-1.233,1.235-1.233c0.682,0,1.234,0.551,1.234,1.233C101.718,98.661,101.166,99.213,100.484,99.213z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_282_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 89.102,
    y: 93.772,
    transform: "matrix(0.0022 -1 1 0.0022 -23.9844 211.0139)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#ADEBF6",
    width: 9.292,
    height: 47.507
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#ADEBF6",
    points: "117.491,122.225 117.499,118.439 69.993,118.165  69.984,122.118  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 106.959,
    y: 116.872,
    transform: "matrix(0.0022 -1 1 0.0022 -6.207 228.9112)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#FFDB76",
    width: 9.292,
    height: 1.388
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 102.159,
    y: 116.855,
    transform: "matrix(0.0022 -1 1 0.0022 -10.9788 224.0937)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#FFDB76",
    width: 9.293,
    height: 1.387
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 100.643,
    y: 116.715,
    transform: "matrix(0.7082 -0.706 0.706 0.7082 -53.385 105.9528)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#333333",
    width: 1.696,
    height: 1.696
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 97.775,
    y: 116.666,
    transform: "matrix(0.7085 -0.7057 0.7057 0.7085 -54.1815 103.8438)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#333333",
    width: 1.696,
    height: 1.696
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_46_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 83.46,
    y: 59.758,
    transform: "matrix(0.0012 -1 1 0.0012 4.4914 171.521)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#FF916E",
    width: 9.292,
    height: 47.509
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#FF916E",
    points: "111.855,88.187 111.858,84.401 64.351,84.176  64.346,88.129  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 101.318,
    y: 82.84,
    transform: "matrix(0.0012 -1 1 0.0012 22.3077 189.4008)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#ADEBF6",
    width: 9.292,
    height: 1.388
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 96.516,
    y: 82.828,
    transform: "matrix(0.0012 -1 1 0.0012 17.5231 184.5869)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#ADEBF6",
    width: 9.292,
    height: 1.387
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 95.001,
    y: 82.692,
    transform: "matrix(0.7085 -0.7057 0.7057 0.7085 -31.016 91.99)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#333333",
    width: 1.696,
    height: 1.697
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 92.132,
    y: 82.647,
    transform: "matrix(0.7077 -0.7065 0.7065 0.7077 -31.8122 90.0982)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#333333",
    width: 1.696,
    height: 1.696
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#333333",
    d: "M103.639,101.056v11.839H69.555 c-3.149-0.14-5.66-2.739-5.66-5.924c0-3.142,2.438-5.711,5.526-5.915H103.639z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#FFFFFF",
    d: "M103.639,101.913v10.125H70.343 c-2.927,0-5.299-2.269-5.299-5.066c0-2.704,2.214-4.913,5.004-5.059H103.639z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#B2B2B2",
    points: "93.372,112.038 93.395,105.25 92.52,105.255  92.52,112.038  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#FF916E",
    points: "88.121,105.277 92.542,105.25 92.617,117.102  90.389,115.226 88.196,117.131  "
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    x: 88.17,
    y: 112.172,
    transform: "matrix(1 -0.0066 0.0066 1 -0.7443 0.5983)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#FF916E",
    width: 4.422,
    height: 2.078
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M91.418,67.778c0,0.802-0.635,1.452-1.419,1.452c-0.784,0-1.418-0.65-1.418-1.452 c0-0.802,0.634-1.452,1.418-1.452C90.784,66.326,91.418,66.976,91.418,67.778z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#333333",
    d: "M103.184,65.096c0-0.98,0-15.688,0-15.688l-13.829,6.258l-13.831-6.258c0,0,0,14.707,0,15.688H103.184z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#333333",
    d: "M103.184,49.409c0,0,0,1.418,0,3.4l-13.832,6.254l-13.828-6.258c0-1.98,0-3.396,0-3.396l13.831,6.259 L103.184,49.409z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#757575",
    points: "89.354,54.218 89.354,55.672 65.453,46.098 65.453,44.776 65.463,44.771 89.354,54.218  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#333333",
    points: "89.354,54.219 65.453,44.767 89.531,35.48 112.809,44.776  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 111.101,
    y: 45.721,
    fill: "#333333",
    width: 1.396,
    height: 14.679
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#333333",
    d: "M114.012,60.925c0-1.222-0.988-2.212-2.213-2.212c-1.223,0-2.213,0.99-2.213,2.212 c0,1.222,0.99,2.215,2.213,2.215C113.024,63.139,114.012,62.146,114.012,60.925z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#333333",
    d: "M113.271,62.034h-2.794c-0.468,1.249-1.502,4.684-0.914,9.391l0,0c0,0.282,1.033,0.511,2.308,0.511 c1.274,0,2.308-0.229,2.308-0.511C114.766,66.718,113.737,63.283,113.271,62.034z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#B2B2B2",
    points: "89.354,54.218 89.355,55.672 112.809,46.098 112.809,44.776 112.799,44.771 89.355,54.218  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#333333",
    d: "M36.78,93.018h-6.034c-0.213,0-0.384-0.173-0.384-0.385s0.171-0.384,0.384-0.384h6.034 c0.212,0,0.384,0.172,0.384,0.384S36.992,93.018,36.78,93.018z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#333333",
    d: "M35.861,88.589h-0.975c-0.212,0-0.385-0.172-0.385-0.385c0-0.211,0.173-0.383,0.385-0.383h0.975 c0.211,0,0.384,0.172,0.384,0.383C36.245,88.417,36.072,88.589,35.861,88.589z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#333333",
    d: "M37.021,97.722h-0.975c-0.212,0-0.385-0.172-0.385-0.385c0-0.211,0.173-0.383,0.385-0.383h0.975 c0.212,0,0.385,0.172,0.385,0.383C37.406,97.551,37.233,97.722,37.021,97.722z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#333333",
    d: "M33.762,88.589h-3.674c-0.213,0-0.384-0.172-0.384-0.385c0-0.211,0.171-0.383,0.384-0.383h3.674 c0.212,0,0.385,0.172,0.385,0.383C34.147,88.417,33.974,88.589,33.762,88.589z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#333333",
    d: "M39.24,84.559h-4.436c-0.212,0-0.385-0.172-0.385-0.384s0.173-0.385,0.385-0.385h4.436 c0.212,0,0.383,0.173,0.383,0.385S39.452,84.559,39.24,84.559z"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInteractivelearning);
export default __webpack_public_path__ + "static/media/interactivelearning.bb7343400c1feb616f8dbce64f09ac97.svg";
export { ForwardRef as ReactComponent };